import { GenericV1ErrorsArray, useSwrMutationApi } from '@hooks/useSwrApi';

interface UseSwrEndInterviewProps {
  locale?: string;
  slug?: string;
  successCallback?: () => void;
  errorCallback?: (error: GenericV1ErrorsArray) => void;
}

/**
 * @description SWR mutation: End interview session
 * - `locale` - The current app locale. Default: 'ro'
 * - `slug` - Optional job slug for job-based interview. If not provided, trigger will be a no-op
 * - `successCallback` - Function to call on successful request
 * - `errorCallback` - Function to call on error
 */
export const useSwrEndInterview = (props: UseSwrEndInterviewProps) => {
  const {
    locale = 'ro',
    slug,
    successCallback,
    errorCallback,
  } = props;

  // Build the URL: job-based (with slug) or CV-based (no slug)
  const url = slug ? `/v1/interview/end/${slug}` : '/v1/interview/end';

  // SWR mutation for GET request
  const {
    data,
    error,
    isMutating,
    reset,
    trigger,
  } = useSwrMutationApi<undefined, undefined>({
    url,
    locale,
    fetcherConfig: {
      method: 'GET',
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) {
          successCallback();
        }
      },
      onError: (err) => {
        if (errorCallback) {
          errorCallback(err);
        }
      },
    },
    toastsOptions: {
      showErrorToast: false, // Don't show toast for end interview
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};

